import React, { useState, useRef } from 'react'
import { TextField, Box, InputAdornment, Button } from '@mui/material'
import { Search, Clear } from '@mui/icons-material'
import { useSelector, useDispatch } from 'react-redux'
import { AiSearchResults } from 'Containers/aiSearch'
import { setAi } from 'Slices/AiSlice'
import { useGetLocationModulesQuery } from 'Services/institution'

export const AiSearch = () => {
  const [searchValue, setSearchValue] = useState('')
  const dispatch = useDispatch()
  const searchInputRef = useRef<HTMLInputElement>(null)

  const { locId, instId } = useSelector((state: any) => state.location)

  const { data: modulesData, isSuccess: modulesSuccess } =
    useGetLocationModulesQuery({ instId, locId }, { skip: !instId || !locId })

  const isAiSearchEnabled = modulesData?.resources.some(
    (module) => module.moduleid === 'virtual_tour_search_ai'
  )

  const handleSearch = (event) => {
    if (event.key === 'Enter') {
      if (
        document.activeElement?.getAttribute('aria-label') === 'clear search' ||
        document.activeElement?.querySelector?.('[aria-label="clear search"]')
      ) {
        handleClearSearch()
        return
      }
      dispatch(setAi({ search: searchValue }))
      event.preventDefault()
    }
  }

  const handleClearSearch = () => {
    setSearchValue('')
    dispatch(setAi({ search: null }))
    // Refocus after the clear button unmounts (it had focus on click / keyboard).
    requestAnimationFrame(() => {
      searchInputRef.current?.focus()
    })
  }

  if (!isAiSearchEnabled) return null

  return (
    <Box component={'div'} sx={{ width: '100%', mb: 2 }}>
      <TextField
        id='outlined-search'
        label='Search'
        aria-label='Search for content'
        type='text'
        size='small'
        placeholder='Search for content'
        value={searchValue}
        onChange={(e) => setSearchValue(e.target.value)}
        onKeyDown={handleSearch}
        inputRef={searchInputRef}
        sx={{
          width: '260px',
          '& .MuiInputBase-input::placeholder': {
            color: '#767676',
            opacity: 1,
          },
        }}
        InputProps={{
          startAdornment: (
            <InputAdornment position='start'>
              <Search />
            </InputAdornment>
          ),
          endAdornment: (
            <InputAdornment position='end'>
              {searchValue.length > 0 && (
                <Button
                  variant='text'
                  sx={{
                    color: 'grey.600',
                    padding: 0,
                    margin: 0,
                    minWidth: 'auto',
                    '&:hover': {
                      color: 'grey.700',
                      backgroundColor: 'secondary.40',
                    },
                    '&:active': {
                      color: 'grey.700',
                      backgroundColor: 'secondary.40',
                    },
                  }}
                  onMouseDown={(e) => e.preventDefault()}
                  onClick={handleClearSearch}
                >
                  <Clear aria-label='clear search' />
                </Button>
              )}
            </InputAdornment>
          ),
        }}
      />
      <AiSearchResults />
    </Box>
  )
}

export default AiSearch
